import { FC } from 'react';
import { BKJIcon } from '@awais4123/fillify-design-library';
import {
  BKJIconNameType,
  IBKJIconProps,
} from '@awais4123/fillify-design-library/lib/components/BKJIcon/BKJIcon.types';

const style = { minWidth: 22, width: 22 };

interface INavMenuIconProps extends IBKJIconProps {
  iconName: BKJIconNameType;
}

export const NavMenuIcon: FC<INavMenuIconProps> = (props) => {
  return <BKJIcon {...props} style={style} color="White" />;
};
